export const shadows = {
  card: '0 1px 4px 0 rgba(0, 0, 0, 0.12), 0 1px 2px 1px rgba(0, 0, 0, 0.04)',
  glow: '0 1px 4px 0 rgba(0, 0, 0, 0.12), 0 1px 2px 1px rgba(0, 0, 0, 0.04), inset 0px 0px 20px 5px rgba(254,252,234,.6)',
};
